export default "__VITE_ASSET__f98174a1__"